import { adminPermision } from "src/constant";

const list2 = [
	{
		id: adminPermision.noPermision,
		content: 'No Permision'
	},
	{
		id: adminPermision.watch,
		content: 'View Only '
	}
]

export default list2;